import { AlertTriangle, ArrowRight } from "lucide-react";
import { Link } from "react-router";

interface LiveLink {
  readonly label: string;
  readonly to: string;
  readonly description: string;
}

interface MountedSurfaceGateProps {
  readonly title: string;
  readonly description: string;
  readonly evidence: string;
  readonly liveLinks: readonly LiveLink[];
}

export function MountedSurfaceGate({
  title,
  description,
  evidence,
  liveLinks,
}: MountedSurfaceGateProps) {
  return (
    <div className="mx-auto max-w-4xl space-y-6">
      <div className="rounded-2xl border border-[var(--color-warning)]/30 bg-[var(--color-warning)]/10 p-6">
        <div className="flex items-start gap-3">
          <AlertTriangle className="mt-0.5 h-5 w-5 text-[var(--color-warning)]" />
          <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-[var(--color-foreground)]">{title}</h1>
            <p className="text-sm text-[var(--color-muted-foreground)]">{description}</p>
            <p className="text-sm text-[var(--color-muted-foreground)]">{evidence}</p>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-background)] p-6">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-[var(--color-muted-foreground)]">
          Live Surfaces
        </h2>
        <div className="mt-4 grid gap-3 md:grid-cols-2">
          {liveLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="rounded-xl border border-[var(--color-border)] bg-[var(--color-card)] p-4 transition hover:border-[var(--color-primary)]/40 hover:bg-[var(--color-surface)]"
            >
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="font-medium text-[var(--color-foreground)]">{link.label}</p>
                  <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">{link.description}</p>
                </div>
                <ArrowRight className="h-4 w-4 text-[var(--color-primary)]" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
